import { __decorate, __metadata } from "tslib";
import { IsUndefinable, LengthWithLVS } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsDefined, IsEnum, IsOptional, IsString, ValidateNested } from 'class-validator';
import { StoreExposeGroup, StoreSpecificTypeEnum, StoreTargetEnum } from '../interface';
import { PatchStoreContactInfoDto } from './PatchStoreContactInfoDto';
import { PatchStoreCountryDto } from './PatchStoreCountryDto';
import { PatchStoreDeliveryDto } from './PatchStoreDeliveryDto';
import { PatchStoreFeaturesFlagsDto } from './PatchStoreFeaturesFlagsDto';
import { PatchStoreGeoLocationDto } from './PatchStoreGeoLocationDto';
import { PatchStoreMailerDto } from './PatchStoreMailerDto';
import { PatchStoreManagerContactInfoDto } from './PatchStoreManagerContactInfoDto';
import { PatchStoreOrderDto } from './PatchStoreOrderDto';
import { PatchStoreOrderValidationDto } from './PatchStoreOrderValidationDto';
import { PatchStorePaymentDto } from './PatchStorePaymentDto';
import { PatchStorePickupDto } from './PatchStorePickupDto';
import { PatchStoreScheduleDto } from './PatchStoreScheduleDto';
let PatchStoreDto = class PatchStoreDto {
    constructor() {
        this.specificType = StoreSpecificTypeEnum.REGULAR;
    }
};
__decorate([
    ApiPropertyOptional({ type: () => String, example: '47bbd89f-e221-41af-bbc8-7957d491f0eb' }),
    Expose({
        groups: [
            StoreExposeGroup.MODEL,
            StoreExposeGroup.READ,
            StoreExposeGroup.CREATE,
            StoreExposeGroup.BASE_PATCH,
            StoreExposeGroup.UPDATE,
            StoreExposeGroup.PATCH,
        ],
    }),
    IsOptional({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.BASE_PATCH] }),
    IsString({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.BASE_PATCH] }),
    __metadata("design:type", String)
], PatchStoreDto.prototype, "defaultStoreId", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'STORE_FROM-SOMEWHERE' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.UPDATE] }),
    IsString({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.UPDATE] }),
    __metadata("design:type", String)
], PatchStoreDto.prototype, "alias", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 50, example: 'Merchant GoParrot' }),
    Expose({
        groups: [
            StoreExposeGroup.MODEL,
            StoreExposeGroup.READ,
            StoreExposeGroup.CREATE,
            StoreExposeGroup.UPDATE,
            StoreExposeGroup.PATCH,
            StoreExposeGroup.BASE_PATCH,
        ],
    }),
    IsOptional({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.BASE_PATCH] }),
    IsString({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.BASE_PATCH] }),
    LengthWithLVS(3, 50, { groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.BASE_PATCH] }),
    __metadata("design:type", String)
], PatchStoreDto.prototype, "title", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 250, example: 'Merchant GoParrot Description' }),
    Expose({
        groups: [
            StoreExposeGroup.MODEL,
            StoreExposeGroup.READ,
            StoreExposeGroup.CREATE,
            StoreExposeGroup.UPDATE,
            StoreExposeGroup.PATCH,
            StoreExposeGroup.BASE_PATCH,
        ],
    }),
    IsOptional({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.BASE_PATCH] }),
    IsString({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.BASE_PATCH] }),
    LengthWithLVS(3, 50, { groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.BASE_PATCH] }),
    __metadata("design:type", String)
], PatchStoreDto.prototype, "subtitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 50 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsString({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    LengthWithLVS(3, 50, { groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStoreDto.prototype, "shortName", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 50 }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsString({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    LengthWithLVS(3, 50, { groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStoreDto.prototype, "name", void 0);
__decorate([
    ApiPropertyOptional({ enum: StoreSpecificTypeEnum, default: StoreSpecificTypeEnum.REGULAR }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.CREATE, StoreExposeGroup.READ, StoreExposeGroup.PATCH] }),
    IsUndefinable({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.PATCH] }),
    IsEnum(StoreSpecificTypeEnum, { always: true }),
    __metadata("design:type", String)
], PatchStoreDto.prototype, "specificType", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.CREATE, StoreExposeGroup.READ, StoreExposeGroup.PATCH] }),
    IsUndefinable({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 50, { groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchStoreDto.prototype, "specificCustomType", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchStoreGeoLocationDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => PatchStoreGeoLocationDto),
    __metadata("design:type", PatchStoreGeoLocationDto)
], PatchStoreDto.prototype, "location", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchStoreContactInfoDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.CREATE] }),
    ValidateNested({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => PatchStoreContactInfoDto),
    __metadata("design:type", PatchStoreContactInfoDto)
], PatchStoreDto.prototype, "contactInfo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchStoreManagerContactInfoDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    ValidateNested({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.CREATE] }),
    Type(() => PatchStoreManagerContactInfoDto),
    __metadata("design:type", PatchStoreManagerContactInfoDto)
], PatchStoreDto.prototype, "managerContactInfo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchStoreCountryDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => PatchStoreCountryDto),
    __metadata("design:type", PatchStoreCountryDto)
], PatchStoreDto.prototype, "country", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchStoreDeliveryDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => PatchStoreDeliveryDto),
    __metadata("design:type", PatchStoreDeliveryDto)
], PatchStoreDto.prototype, "delivery", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchStoreFeaturesFlagsDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => PatchStoreFeaturesFlagsDto),
    __metadata("design:type", PatchStoreFeaturesFlagsDto)
], PatchStoreDto.prototype, "featuresFlags", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchStoreDto.prototype, "shortTermFeatureFlags", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchStoreMailerDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => PatchStoreMailerDto),
    __metadata("design:type", PatchStoreMailerDto)
], PatchStoreDto.prototype, "mailer", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchStoreOrderDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => PatchStoreOrderDto),
    __metadata("design:type", PatchStoreOrderDto)
], PatchStoreDto.prototype, "order", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchStorePaymentDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    ValidateNested({ always: true }),
    Type(() => PatchStorePaymentDto),
    __metadata("design:type", PatchStorePaymentDto)
], PatchStoreDto.prototype, "payment", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchStorePickupDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.CREATE, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => PatchStorePickupDto),
    __metadata("design:type", PatchStorePickupDto)
], PatchStoreDto.prototype, "pickup", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchStoreScheduleDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => PatchStoreScheduleDto),
    __metadata("design:type", PatchStoreScheduleDto)
], PatchStoreDto.prototype, "schedule", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchStoreDto.prototype, "diningOptionsConfig", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchStoreOrderValidationDto }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsDefined({ groups: [StoreExposeGroup.UPDATE] }),
    ValidateNested({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    Type(() => PatchStoreOrderValidationDto),
    __metadata("design:type", PatchStoreOrderValidationDto)
], PatchStoreDto.prototype, "orderValidation", void 0);
__decorate([
    ApiPropertyOptional({ enum: StoreTargetEnum }),
    Expose({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.CREATE, StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsEnum(StoreTargetEnum, {
        groups: [StoreExposeGroup.CREATE, StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchStoreDto.prototype, "targetType", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: false }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    IsBoolean({ groups: [StoreExposeGroup.PATCH, StoreExposeGroup.CREATE] }),
    __metadata("design:type", Boolean)
], PatchStoreDto.prototype, "isImported", void 0);
PatchStoreDto = __decorate([
    Expose({
        groups: [
            StoreExposeGroup.MODEL,
            StoreExposeGroup.READ,
            StoreExposeGroup.CREATE,
            StoreExposeGroup.PATCH,
            StoreExposeGroup.UPDATE,
            StoreExposeGroup.BASE_PATCH,
        ],
    })
], PatchStoreDto);
export { PatchStoreDto };
//# sourceMappingURL=PatchStoreDto.js.map